import { Box, Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import moment from 'moment';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';

const storageId = sessionStorage.getItem('idUsuario');
export default function TabIngreso({
    idCapa,
    isNew,
    allowedWrite,
    onChange,
    capaFormData
}) {
    const updatedInputs = useMemo(() => {
        return (structuredClone(inputs).map(input => {
            switch (input.name) {
                default:
                    break;
            }
            if (!allowedWrite) {
                input.disabled = true;
            }
            return input;
        }))
    }, [
        allowedWrite,
    ]);

    const onClickAgregarProrroga = () => {
        const prorrogas = capaFormData?.stage2?.prorrogaCapa ?? [];

        // Validar si ya tiene 2 prorrogas
        if (prorrogas.length >= 2) {
            toast.error('No se pueden agregar más de 2 prorrogas.');
            return;
        }

        // Validar si ya tiene una prorroga cargada
        if (prorrogas.length === 1) {
            const prorroga = prorrogas[0];

            // Revisar si tiene IdProrrogaCapa y está aprobada
            if (prorroga.idProrrogaCapa && !!prorroga.aprobada) {
                const fechaProrroga = moment(prorroga.fechaProrroga);
            } else {
                toast.error('No se puede agregar otra prórroga, ya existe una prórroga sin aprobar.');
                return;
            }
        }

        // Calcular fecha de la nueva prórroga
        const nuevaFechaProrroga =
            prorrogas.length === 1
                ? moment(prorrogas[0].fechaProrroga).add(1, 'days') // Fecha mayor a la primera prórroga por default
                : capaFormData?.stage2?.fechaAccion;

        // Agregar nueva prórroga
        handleInputChange('prorrogaCapa', [
            ...prorrogas,
            {
                fechaProrroga: nuevaFechaProrroga,
                justificacion: '',
                idUsuarioAlta: parseInt(storageId),
                idGestionCapa: idCapa,
                fechaAlta: moment(),
                aprobada: false
            }
        ]);
    };

    const handleChangeProrroga = (field, value, index) => {
        const updatedProrrogas = capaFormData?.stage2?.prorrogaCapa?.map((prorroga, idx) =>
            idx === index ? { ...prorroga, [field]: value } : prorroga
        ) || [];

        handleInputChange('prorrogaCapa', updatedProrrogas);
    };

    const handleInputChange = useCallback((fieldName, value) => {
        onChange({
            [fieldName]: value
        });
    }, [onChange]);
    return (
        <div>
            <Grid container spacing={2}>
                {updatedInputs
                    .filter(input => !input.positionFinal)
                    .map((input, index) => (
                        <Grid key={`input-${input.name}-index-${index}`} size={{ xs: input.col }}>

                            {
                                input.name === 'agregarProrroga' && allowedWrite ?
                                    <>
                                        <Grid size={{ xs: 8 }}>
                                            <Box>

                                                <CustomButton
                                                    label='Agregar prorroga'
                                                    variant='outlined'
                                                    onClick={onClickAgregarProrroga}
                                                    sx={{ ml: 1 }}
                                                />
                                            </Box>
                                        </Grid>
                                    </>
                                    :
                                    input.name === 'prorrogaCapa' ?
                                        capaFormData?.stage2?.prorrogaCapa?.map((prorroga, index) => (
                                            <div
                                                key={`prorroga-${prorroga.idUsuarioAlta || index}`}
                                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px' }}
                                            >
                                                <Grid size={{ xs: 1.9 }}>
                                                    <RenderInputByTypeMobile
                                                        input={{
                                                            displayName: `Fecha prorroga ${index > 0 ? '(' + (index + 1) + ')' : ''}`,
                                                            name: 'fechaProrroga',
                                                            type: 'date',
                                                            disabled: (!!prorroga.idProrrogaCapa && prorroga.aprobada) || !allowedWrite,
                                                            required: true,
                                                        }}
                                                        handleChange={(_, value) => handleChangeProrroga('fechaProrroga', value, index)}
                                                        value={prorroga.fechaProrroga}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 9.9 }}>
                                                    <RenderInputByTypeMobile
                                                        input={{
                                                            displayName: `Justificación y Riesgo de Prórroga ${index > 0 ? '(' + (index + 1) + ')' : ''}`,
                                                            name: 'justificacion',
                                                            type: 'long_string',
                                                            disabled: (!!prorroga.idProrrogaCapa && prorroga.aprobada) || !allowedWrite,
                                                            required: true,
                                                        }}
                                                        handleChange={(_, value) => handleChangeProrroga('justificacion', value, index)}
                                                        value={prorroga.justificacion}
                                                    />
                                                </Grid>
                                            </div>
                                        ))
                                        :
                                        <RenderInputByTypeMobile
                                            key={`input-${input.name}-index-${index}`}
                                            input={input}
                                            handleChange={handleInputChange}
                                            value={capaFormData?.stage2[input.name]}
                                        />
                            }
                        </Grid>))}
                <Grid size={{ xs: 6 }} />
            </Grid>
        </div>
    )
}

const inputs = [

    {
        name: 'fechaAccion',
        displayName: 'Fecha acción',
        type: 'date',
        disabled: true,
        col: 2.5
    },
    {
        name: 'agregarProrroga',
        type: 'item',
        hidden: true,
        disabled: false,
        col: 4
    },
    //row
    {
        name: 'prorrogaCapa',
        type: 'item',
        hidden: true,
        disabled: false,
        col: 12
    },
    //row
    {
        name: 'fechaCierreAccion',
        displayName: 'Fecha cierre acción',
        type: 'date',
        col: 2.5
    },
];